import PropTypes from "prop-types"
import React, { useEffect, useMemo, useState } from "react"
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../../../components/Common/BreadcrumbFilters"

//i18n
import { withTranslation } from "react-i18next"

//redux
// import { branches } from "./../../../../common/data/companies"
import { useDispatch, useSelector } from "react-redux"
import { getClassNames as onList } from "store/actions"
import TableContainerServerSide from "components/Common/TableContainerServerSide"

//Custom CSS
import "./custom.scss"
import moment from "moment"
import { Link } from "react-router-dom"
import { replaceAll } from "helpers/functions"
import TableContainer from "../../../../components/Common/TableContainer"
import { isEmpty } from "lodash"

const ClassNames = props => {
  //meta title
  document.title = props.t("ClassNames")

  const dispatch = useDispatch()
  const { error, classNames, loading } = useSelector(state => ({
    error: state.ClassNames?.error,
    classNames: state.ClassNames?.data || [],
    loading: state.ClassNames?.loading || false,
  }))

  const breadcrumbItems = [
    { title: props.t("Companies"), link: "/settings" },
    { title: props.t("ClassNames"), link: "/" },
  ]

  const [selectedItem, setSelectedItem] = useState("all")
  const [tableSetting, setTableSetting] = useState({
    orderBy: "createdAt",
    ascDesc: -1,
    limit: 5,
    page: 0,
    select: "name",
    search: "",
  })
  const [data, setData] = useState([])
  const [load, setLoad] = useState(false)

  const {
    match: { params },
  } = props

  useEffect(() => {
    if (isEmpty(classNames) && load == false) {
      setLoad(true)
      dispatch(onList())
    } else {
      setData(classNames)
    }
  }, [classNames])

  // useEffect(()=>{
  //   if(isEmpty(data) && !isEmpty(params.id)){
  //     setData(branches.filter(x=>x.companyId == params.id))
  //   }
  // },[])

  const columns = useMemo(
    () => [
      {
        Header: props.t("ClassName Name"),
        accessor: "name",
        search: false,
      },
      {
        Header: "",
        accessor: "_id",
        search: false,
        Cell: ({ value }) => (
          <div>
            <Link
              to={`/settings/class-names/edit/${value}`}
              className="btn btn-sm btn-warning text-white me-2"
            >
              {props.t("Edit")}
            </Link>
          </div>
        ),
      },
    ],
    []
  )

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={props.t("ClassNames")}
            backLink={"/settings"}
            breadcrumbItems={breadcrumbItems}
            isAdd={true}
            addTitle={props.t("Create ClassName")}
            addHandle={() => {
              props.history.push("/settings/class-names/create")
            }}
            className={"mb-0 pb-0"}
          />

          {/* <TableContainerServerSide
            loading={loading}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isAddOptions={false}
            tableSetting={tableSetting}
            customPageSize={tableSetting.limit}
            className="custom-header-css"
            totalCount={classNamesTableOptions?.productTotal || 0}
            queryPageIndex={tableSetting.page}
            queryPageSize={tableSetting.limit}
            tableOptions={classNamesTableOptions}
            action={(pageIndex, pageSize, search) => {
              setTableSetting({
                orderBy: "createdAt",
                ascDesc: -1,
                limit: pageSize,
                page: pageIndex,
                select: tableSetting.select,
                search: search,
              })
            }}
          /> */}
 
          <TableContainer
            loading={loading}
            columns={columns}
            data={data}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

ClassNames.propTypes = {
  t: PropTypes.any,
  history: PropTypes.object,
}

export default withTranslation()(ClassNames)
